import axios from 'axios';

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'https://api.lawoc.site' });

API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('lawoc_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// AUTH
export const authLogin    = (email, password)       => API.post('/api/auth/login',          { email, password });
export const authRegister = (name, email, password) => API.post('/api/auth/register',        { name, email, password });
export const authMe       = ()                      => API.get('/api/auth/me');
export const authChangePw = data                    => API.post('/api/auth/change-password', data);

// DOCUMENTS
export const docsSearch     = (q='', category='')  => API.get('/api/documents/search',           { params: { q, category } });
export const docsCategories = ()                    => API.get('/api/documents/categories');
export const docsDownload   = id                    => API.get(`/api/documents/${id}/download`,   { responseType: 'blob' });
export const docsRead       = id                    => API.get(`/api/documents/${id}/read`,       { responseType: 'blob' });
export const docsUpload     = formData              => API.post('/api/documents',                  formData);
export const docsUpdate     = (id, data)            => API.put(`/api/documents/${id}`,             data);
export const docsDelete     = id                    => API.delete(`/api/documents/${id}`);
export const docsSyncDrive  = ()                    => API.post('/api/documents/admin/sync-drive');
export const docsDriveFiles = ()                    => API.get('/api/documents/admin/drive-files');

// COLLECTION
export const colGet       = ()             => API.get('/api/collection');
export const colSave      = documentId     => API.post('/api/collection',              { documentId });
export const colRemove    = documentId     => API.delete(`/api/collection/${documentId}`);
export const colAddTag    = (colId, name)  => API.post(`/api/collection/${colId}/tags`, { tagName: name });
export const colRemoveTag = tagId          => API.delete(`/api/collection/tags/${tagId}`);

// CHAT
export const chatSend = (message, sessionId) => API.post('/api/chat', { message, sessionId });

// BLOG
export const blogList     = (category='') => API.get('/api/blog',          { params: { category } });
export const blogGet      = slug           => API.get(`/api/blog/${slug}`);
export const blogAdminAll = ()             => API.get('/api/blog/admin/all');
export const blogCreate   = data           => API.post('/api/blog',          data);
export const blogUpdate   = (id, data)     => API.put(`/api/blog/${id}`,     data);
export const blogDelete   = id             => API.delete(`/api/blog/${id}`);

// PAGES CMS
export const pageBySlug    = slug        => API.get('/api/pages/by-slug',  { params: { slug } });
export const pageTemplates = ()          => API.get('/api/pages/templates');
export const pageAdminAll  = ()          => API.get('/api/pages/admin/all');
export const pageCreate    = data        => API.post('/api/pages',         data);
export const pageUpdate    = (id, data)  => API.put(`/api/pages/${id}`,    data);
export const pageDelete    = id          => API.delete(`/api/pages/${id}`);

// PAYMENTS
export const payCreateQR     = ()    => API.post('/api/payments/create-qr');
export const payStatus        = ref  => API.get(`/api/payments/status/${ref}`);
export const payTransactions  = ()   => API.get('/api/payments/admin/transactions');
export const payApprove       = id   => API.post(`/api/payments/admin/${id}/approve`);

// ADMIN
export const adminStats      = ()             => API.get('/api/admin/stats');
export const adminUsers      = ()             => API.get('/api/admin/users');
export const adminRoleChange = (id, role, exp)=> API.put(`/api/admin/users/${id}/role`, { role, expiresAt: exp });
export const adminUserDelete = id             => API.delete(`/api/admin/users/${id}`);
export const adminAuditLog   = ()             => API.get('/api/admin/audit-log');

// Extract a human-readable error message, including from blob (PDF) responses
export const apiErrText = async (e) => {
  const d = e?.response?.data;
  if (d instanceof Blob) {
    try { return JSON.parse(await d.text()).error || `Request failed (HTTP ${e.response.status})`; }
    catch { return `Request failed (HTTP ${e.response.status})`; }
  }
  return d?.error || e.message;
};

export default API;
